import { ArrowRight, Download as DownloadIcon, ExternalLink, TerminalSquare } from 'lucide-react';
import { GITHUB_URL } from '../siteContent';

export default function Hero({ content }) {
  return (
    <section className="hero" id="top">
      <div className="hero-background" aria-hidden="true">
        <img src="/screenshot.png" alt="" />
      </div>
      <div className="hero-inner">
        <div className="hero-copy">
          <p className="hero-badge">
            <span className="hero-badge-mark" />
            {content.badge}
          </p>
          <h1>{content.title}</h1>
          <p className="hero-lede">{content.lede}</p>

          <div className="hero-actions">
            <a className="btn-primary" href="#download">
              <DownloadIcon size={17} />
              <span>{content.download}</span>
            </a>
            <a className="btn-secondary" href="#start">
              <span>{content.primary}</span>
              <ArrowRight size={17} />
            </a>
            <a className="btn-secondary" href={GITHUB_URL} target="_blank" rel="noopener noreferrer">
              <ExternalLink size={16} />
              <span>{content.repository}</span>
            </a>
            <a className="btn-ghost" href="#build">
              <TerminalSquare size={16} />
              <span>{content.build}</span>
            </a>
          </div>
        </div>

        <div className="hero-command" aria-label={content.codeLabel}>
          <div className="command-dots" aria-hidden="true">
            <span />
            <span />
            <span />
          </div>
          <code>{content.command}</code>
        </div>

        <div className="hero-stats" aria-label="Project highlights">
          {content.stats.map((stat) => (
            <div className="hero-stat" key={stat.value}>
              <strong>{stat.value}</strong>
              <span>{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
